import { normalizeSessionStatus, formatSessionDate } from './interviewShared';

export const PITCH_TYPE_LABELS = {
  networking: 'Networking',
  recruiter: 'Recruiter Screen',
  investor: 'Investor / Startup',
};

export const DURATION_OPTIONS = [30, 60, 90];

export function normalizePitchSession(row) {
  const overallScore = row.AnalyzedJSON?.overall_feedback?.overall_score;
  const typeLabel = PITCH_TYPE_LABELS[row.PitchType] || row.PitchType || 'Elevator Pitch';
  return {
    id: row.PitchPracticeID,
    role: `${typeLabel} · ${row.DurationSeconds || '—'}s`,
    score: Number.isFinite(overallScore) ? Math.round(overallScore) : null,
    date: formatSessionDate(row.CreatedOn),
    status: normalizeSessionStatus(row.Status),
    failureReason: row.AnalysisErrorMessage || null,
  };
}

export function pitchRating(score100) {
  if (score100 == null) return 'Pending';
  if (score100 >= 80) return 'Strong';
  if (score100 >= 60) return 'Developing';
  return 'Needs Work';
}

export function pitchHeadline(score100) {
  if (score100 == null) return 'Your pitch is being scored.';
  if (score100 >= 80) return 'Strong pitch. Keep sharpening the details.';
  if (score100 >= 60) return 'Solid base. A few focused tweaks will lift this.';
  return "Key gaps to work on. Let's close them.";
}
